import { Plus } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { PlatformIcon } from "@/features/identity/components/PlatformIcon";

export function AddLinkMenu({ available, onAdd }) {
  if (!available.length) {
    return <p data-testid="add-link-all-added" className="text-xs text-muted-foreground">All supported platforms have been added.</p>;
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid="add-link-button" className="mw-btn mw-btn-ghost">
          <Plus className="h-4 w-4" /> Add link
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {available.map((p) => (
          <DropdownMenuItem key={p.key} onSelect={() => onAdd(p.key)} data-testid={`add-link-option-${p.key}`} className="flex min-h-[44px] cursor-pointer items-center gap-3">
            <PlatformIcon platform={p.key} />
            {p.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
